<template>
  <ElDialog
      v-model="isShow"
      :title="$t('common.share.detail')"
      :footer="null"
      centered
      :width="520"
      destroyOnClose
      @cancel="close"
  >
    <template #default>
      <div style="width: 100%;display: flex;flex-direction: column;justify-content: center;align-items: center">
        <div style="width: 100%;display: flex;justify-content: center;align-items: center">
          <template v-if="activeItem.length===1">
            <div v-if="activeItem[0].isFolder===1"
                 style="display: flex;flex-direction:column;justify-content: center;align-items: center;width: 100%">
              <FileIcon :fileExtend="activeItem[0]?.fileExtend?.toLowerCase()" :fileUrl="activeItem[0].fileExtendPath"
                        :size="60" :isAbbreviation="true"></FileIcon>
              <span
                  style="width: 150px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-top: 20px;text-align: center;font-size: 13px;">
              {{
                  activeItem[0]?.fileName
                }}
            </span>
            </div>
            <div v-if="activeItem[0].isFolder===2"
                 style="display: flex;flex-direction:column;justify-content: center;align-items: center;width: 100%;font-size: 13px;">
<span style="display: inline-block;height: 24px" class="icon"><i aria-label="图标: folder"
                                                                 class="anticon anticon-folder"
                                                                 style="color: rgb(41, 182, 246); font-size: 60px;"><svg
    viewBox="64 64 896 896" data-icon="folder" width="1em" height="1em" fill="currentColor"
    aria-hidden="true" focusable="false" class=""><path
    d="M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z"></path></svg></i></span>
              <span link type="primary" class="pointer"
                    style="width: 150px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-top: 40px;text-align: center;font-size: 13px;">
                {{ activeItem[0].fileName }}
              </span>
            </div>
          </template>
          <template v-else>
            <div style="width: 100%;display: flex;justify-content: center;align-items: center;flex-direction: column">
              <svg t="1744956733416" class="icon" viewBox="0 0 1024 1024" version="1.1"
                   xmlns="http://www.w3.org/2000/svg"
                   p-id="2657" width="60" height="60">
                <path
                    d="M170.2 246.4h342.1s44.2-77.8 89.1-77.8h254.9c20.7 0 37.7 19.8 37.7 44l1.1 598.1c0 24.2-19.8 44-44 44h-681c-24.2 0-44-19.8-44-44V290.4c0.1-24.2 19.9-44 44.1-44z"
                    fill="#694B4B" p-id="2658"></path>
                <path d="M862.9 671.5l-688 38.3-22.2-406.4 688.1-59.3z" fill="#593F3F" p-id="2659"></path>
                <path d="M870.8 671.8L242.2 707l-21.1-388 634.6-35.2z" fill="#593F3F" p-id="2660"></path>
                <path d="M840.7 673.7L218.1 725l-21.9-383.4 623.4-55.9z" fill="#FFFFFF" p-id="2661"></path>
                <path d="M807.9 715.1L178.6 750l-22.2-406.3 629.7-48.1z" fill="#F2F2F1" p-id="2662"></path>
                <path d="M796 713.5l-619 36.3-22.1-406.3 618.8-40.1z" fill="#FFFFFF" p-id="2663"></path>
                <path
                    d="M895.2 425.1H509.1s-44.2-71.4-89.1-71.4H125.1c-20.7 0-38.9 16.3-38.9 36l40 429.2c0 19.7 19.8 35.8 44 35.8h685c24.2 0 44-16.1 44-35.8l40-358c0-19.7-19.8-35.8-44-35.8z"
                    fill="#00B5FC" p-id="2664"></path>
              </svg>
              <span type="primary" class="pointer"
                    style="width: 200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-top: 10px;text-align: center;font-size: 13px">
                {{ activeItem[0].fileName }}
              </span>
              <span type="primary" class="pointer"
                    style="width: 100px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-top: 10px;text-align: center;font-size: 13px">
               {{ $t('share.file.text1') }}
                <span style="color: #0a84ff;font-weight: 500;font-size: 13px">
                  {{
                    activeItem.length
                  }}
                </span>
                {{ $t('share.file.text2') }}
              </span>
            </div>
          </template>
        </div>
        <div style="margin-top: 20px;width: 200px;display: flex;align-items: center;justify-content: flex-start">
          <div style="width: 80px;font-size: 13px;">{{ $t('share.date.time') }}</div>
          <el-select
              v-model="shareDay"
              style="width: 100%;"
              remote
              size="small"
              allow-create
              :placeholder="$t('common.please.input')"
          >
            <el-option :label="$t('common.select.targetDays',{count:5})" :value="5"></el-option>
            <el-option :label="$t('common.select.targetDays',{count:7})" :value="7"></el-option>
            <el-option :label="$t('common.select.targetDays',{count:15})" :value="15"></el-option>
            <el-option :label="$t('common.select.targetDays',{count:30})" :value="30"></el-option>
          </el-select>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="dialog-footer">
        <ElButton size="small" @click="close">{{
            $t("common.cancel")
          }}
        </ElButton>
        <ElButton size="small" type="primary" @click="createLink" :loading="loading">{{
            $t("common.create.share.link.to")
          }}
        </ElButton>
      </div>
    </template>
  </ElDialog>
</template>

<script setup>
import {ElButton, ElDialog, ElInput, ElMessage} from "element-plus";
import {ref, defineProps, watch, defineEmits, onMounted, computed} from 'vue'
import {useStore} from "vuex";
import useClipboard from "vue-clipboard3";
import FileIcon from "@/components/File/FileIcon.vue";

const store = useStore();
const emit = defineEmits()
const isShow = ref(false);
const loading = ref(false)
const {toClipboard} = useClipboard();

const {value, isHeadLine, activeItem} = defineProps({
  value: {type: Boolean, default: false},
  isHeadLine: {type: Boolean, default: false},
  activeItem: {type: Array, default: []}
})

const shareDay = ref(5)

watch(() => value, (val) => {
  isShow.value = val;
}, {immediate: true})

const close = () => {
  emit("close");
}

// 关闭链接并将内容复制到剪切板
const createLink = async () => {
  emit("showLink", {shareDay: shareDay.value, fileName: activeItem[0]?.fileName})
  close();
}
</script>
<style scoped lang="less">
.fx-j-c {
  display: flex;
  justify-content: center;
  margin-top: 40px;
}

.title_cdir {
  color: rgba(0, 0, 0, .85);
  font-weight: 700;
  font-size: 14px;
}

.fx-j-r {
  display: flex;
  justify-content: right;
  margin-top: 40px;
}

</style>
